// It's use for Login, register pages only

import { mapGetters, mapState } from 'vuex'
export default {
    data: () => ({
        displayModal: false,
    }),
    computed: {
        ...mapGetters({
            isWebsiteMaintenance: 'settings/isWebsiteMaintenance',
        }),
        ...mapState({
            supportCountryAndLanguage: (state) =>
                state.settings.supportCountryAndLanguage,
            defaultCurrency: (state) => state.settings.defaultCurrency,
        }),
    },
    watch: {
        supportCountryAndLanguage(value) {
            this.checkIsWebsiteMaintenanceForInternational()
        },
    },
    mounted() {
        this.checkIsWebsiteMaintenanceForInternational()
    },
    methods: {
        checkIsWebsiteMaintenanceForInternational() {
            const result = this.isWebsiteMaintenance(this.defaultCurrency)
            if (result && result.status) {
                this.displayModal = false
            } else {
                this.displayModal = true
            }
        },
    },
}
